var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationBigWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.62 57.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xC9rtes\\xEDt\\xE9s_nagy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.76,38l6.86,5.45v3H1v-3l6.85-5.49V25.26A16,16,0,0,1,20.69,9.61a15.86,15.86,0,0,1,6.24,0A15.94,15.94,0,0,1,39.76,25.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.86,49.79a2.3,2.3,0,0,1,0,.37,6.07,6.07,0,0,1-12.14,0,2.3,2.3,0,0,1,0-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.93,6.21a3.48,3.48,0,0,0,.42-1.67,3.55,3.55,0,0,0-7.09,0,3.38,3.38,0,0,0,.43,1.67"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBigWhite);
export default __webpack_public_path__ + "static/media/notificationBigWhite.0721c961a5539bc08bdfa31bc06f337c.svg";
export { ForwardRef as ReactComponent };